import { useState } from "react";
import DownloadIconDesign from "../../../common/DownloadIconDesign";
import { fetchFullDataQMF } from "../../../../api/fetchFullDataQMF";
import { generateQualityManualPDF } from "../../../../utils/generateQualityManualPDF";
import { CircularProgress, Snackbar, Alert } from "@mui/material";

function DownloadButton() {
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [pdfDocument, setPdfDocument] = useState(null);

  // Function to handle PDF generation and preview
  const handleDownload = async () => {
    try {
      setLoading(true);
      // Fetch the QMF data
      const data = await fetchFullDataQMF();

      if (!data || data.length === 0) {
        setNotification({
          open: true,
          message: "No data available to generate PDF",
          severity: "error",
        });
        setLoading(false);
        return;
      }

      // Generate the PDF
      const doc = generateQualityManualPDF(data[0]);
      if (!doc) {
        setNotification({
          open: true,
          message: "Failed to generate PDF",
          severity: "error",
        });
        setLoading(false);
        return;
      }

      // Save the document for future use
      setPdfDocument(doc);

      // Only preview the PDF in a new tab - don't automatically download
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Open the PDF in a new tab
      const newWindow = window.open(pdfUrl, "_blank");
      if (!newWindow) {
        // If popup blocked, provide direct download link
        setNotification({
          open: true,
          message: "PDF preview was blocked. Please check your popup settings.",
          severity: "warning",
        });
        // Fallback to direct download with corrected filename
        doc.save("1Source Quality Manual.pdf");
      } else {
        setNotification({
          open: true,
          message:
            "PDF opened for preview. Use browser's download button to save.",
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      setNotification({
        open: true,
        message: "Error generating PDF",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Single Download button that previews and downloads */}
      <DownloadIconDesign onClick={handleDownload} disabled={loading}>
        {loading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          "Download PDF"
        )}
      </DownloadIconDesign>

      {/* Notification snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={5000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setNotification({ ...notification, open: false })}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default DownloadButton;
